import React, { FC, useContext } from 'react';
import clsx from 'clsx';

import { PerformanceMetricsBalanceSheetTopDebtAccountItem } from '@futrli-sdk/predict';

import { formatCurrency, FormattedMessage, useIntl } from '@futrli/localisation';
import { PredictManagementContext } from '../../../../predict-management/context/predict-management-context';
import parentStyles from '../performance.scss';
import styles from './top-debt-balances.scss';

interface Props {
  data: PerformanceMetricsBalanceSheetTopDebtAccountItem[];
}
export const TopDebtBalances: FC<Props> = ({ data }: Props) => {
  const intl = useIntl();
  const { currency } = useContext(PredictManagementContext);
  return (
    <section className={clsx(parentStyles.card)}>
      <h3 className={clsx(parentStyles.cardTitle)}>
        <FormattedMessage id="predict.top_debt_balances" defaultMessage="Top debt balances" />
      </h3>
      {data.length ? (
        <table className={clsx(styles.topDebtTable)}>
          <tbody>
            {data.map((e, i) => (
              <tr key={i}>
                <td className={clsx('uiTypeFont16Medium')}>{formatCurrency(+e.amount, intl, currency || '', 0, 0)}</td>
                <td className={clsx('uiTypeFont12Regular')}>{e.name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className={clsx('uiTypeFont14RegularLight', styles.noData)} data-testid="no-data-text">
          <FormattedMessage id="predict.no_data_available" defaultMessage="No data available" />
        </p>
      )}
    </section>
  );
};
